module.exports = __webpack_public_path__ + "static/media/531.52f0055d.png";